/*
 * @Description: 首页 板块模板
 * @Author: ma.cq
 * @Date: 2018-11-09 14:19:04
 * @LastEditors: ma.cq
 * @LastEditTime: 2018-11-09 18:43:17
 */
<template>
  <section class="panel">
    <header class="header">
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-caidan"></use>
      </svg>
      <span class="title">{{title}}</span>
      <svg v-if="icon" @click="$emit('iconClick')" class="icon can-click" aria-hidden="true">
        <use :xlink:href="`#icon-${icon}`"></use>
      </svg>
    </header>
    <div class="bg-white">
      <slot></slot>
    </div>
  </section>
</template>
<script>
export default {
  name: 'panel',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.panel{
  width: 100%;
}
.header{
  height: 48px;
  line-height: 48px;
  background-color: #f7f7f7;
  color: #666;
  .icon {
    width: 16px;
    height: 16px;
  }
  .title{
    font-size: 14px;
    margin: 0 10px 0 4px;
  }
  .can-click{
    cursor: pointer;
    color: $primary-color;
    transition: transform .5s;
  }
  .can-click:hover{
    transform: rotateZ(180deg);
  }
}
.bg-white{
  background-color: white;
}
</style>
